import {
  useLoaderData,
  useMatches,
  useParams,
  Scripts as ReactRouterScripts,
} from 'react-router';

// oxlint-disable-next-line typescript/no-explicit-any
export function useRootLayoutProps(_: any) {
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    loaderData: useLoaderData(),
    matches: useMatches(),
    params: useParams(),
  };
}

export function Scripts() {
  return <ReactRouterScripts />;
}
